<template>
  <div>
    <div
      :class="[
        'container',
        'grid-container',
        motivoConfig.mancheta ? 'grid-container--2-5-3-2' : 'layout-centrado'
      ]"
    >
      <div class="col2">
        <div class="image">
          <img
            src="@/assets/img/1x/location-buildings-bbva-branch.svg"
            alt="Sucrusal BBVA"
          />
        </div>

        <div class="mensaje-wrapper">
          <p class="title">Acércate a una sucursal</p>
          <p
            v-for="(line, idx) in motivoConfig.subtitles"
            :key="idx"
            class="subtitle"
          >
            {{ line }}
          </p>
        </div>

        <div class="button-container">
          <sales-button
            @click.native="goLink"
            class="sales-button"
            label="Ver sucursales"
            :color="color"
          />
        </div>
      </div>

      <div v-if="motivoConfig.mancheta" class="col3" style="margin-top: 20px">
        <mancheta
          class="mancheta"
          v-if="motivoConfig.mancheta"
          quantumObfuscate
          :text="motivoConfig.mancheta.text"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SalesButton from "@/components/core/SalesButton";
import Mancheta from "@/components/core/Mancheta";

const CONFIG = {};

// Opción por defecto:
CONFIG.general = {
  title: "Acercate a una sucursal",
  subtitles: [
    "Podés terminar de activar tu cuenta presentando tu DNI y la documentación que acredite tus ingresos según tu actividad (como pago de monotributo o recibo de sueldo)."
  ],
  mancheta: {
    text:
      "<strong>Importante</strong> <br> En caso de ser Sujeto Obligado, deberás presentar la constancia de inscripción ante la UIF.  Si, además, tributás en el extranjero, deberás llevar el número de identificación fiscal del país. Por último, si sos PEP, deberás acreditar tu condición socioeconómica."
  }
};

// Pep / Fatca / SO
CONFIG["mensaje-1"] = CONFIG.general;

// COELSA
CONFIG["mensaje-2"] = {
  subtitles: [
    "No es posible completar el alta de tu cuenta de forma digital.",
    "Para continuar con la gestión, acercate a una sucursal BBVA. Nuestro equipo de asesoramiento te ayudará con el proceso."
  ],
  mancheta: null
};

// Riesgo PCGB
CONFIG["mensaje-3"] = CONFIG.general;

export default {
  name: "ContinuaSucursal",
  data() {
    return {
      color: "#001391",
      link: "https://buscador.bbva.com.ar/buscadordecajerosysucursales/"
    };
  },
  components: {
    SalesButton,
    Mancheta
  },
  methods: {
    goLink() {
      window.location.href = this.link;
    }
  },
  computed: {
    motivoConfig() {
      return CONFIG[this.$route.params.mensaje] || CONFIG.general;
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 600px) {
  .image {
    margin-top: 60px;
  }
  img {
    text-align: center;
  }
  .image img:last-child {
    text-align: center;
    width: 190px;
    margin-top: -24px;
  }
  .image img.error-sms {
    width: 350px !important;
  }
  .error-envio-sms {
    margin-left: -10px;
  }
  .box_img img {
    width: 25px;
    margin: 2px 30px 10px 0;
  }
  .sales-button {
    height: 56px;
    width: 150px !important;
  }
  .box_link {
    align-items: baseline;
    justify-content: center;
    padding-top: 20px;
    height: 75px;
    display: flex;
  }
  p.nombre {
    font-size: 28px;
    margin-bottom: 32px;
  }
  div.mensaje-wrapper {
    color: #121212;
    font-size: 18px;
    margin-bottom: 42px;
    text-align: center;
  }
  div.button-container {
    text-align: left;
  }
  div.image {
    text-align: left;
  }
  .title {
    font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
    font-size: 26px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #121212;
    margin-bottom: 8px;
    margin-top: 7px;
  }
  .subtitle {
    font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #121212;
  }
  span.subtitle-sucursal {
    font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    line-height: 1.6;
    text-align: center;
    color: #121212;
  }
  .container {
    text-align: center;
  }
  .dni {
    width: 149px;
    height: 105px;
  }
  .layout-centrado {
    grid-template-areas: ". . . col2 col2 col2 col2 col2 col2 . . .";
  }
  .layout-centrado .title,
  .layout-centrado .subtitle {
    text-align: center;
  }
  .layout-centrado div.button-container,
  .layout-centrado div.image {
    text-align: center;
  }
}

@media screen and (max-width: 600px) {
  .image {
    margin-top: 60px;
  }
  img {
    text-align: center;
  }
  .image img:last-child {
    text-align: center;
    width: 190px;
    margin-top: -24px;
  }
  .image img.error-sms {
    width: 350px !important;
  }
  .error-envio-sms {
    margin-left: -10px;
  }
  .box_img img {
    width: 25px;
    margin: 2px 30px 10px 0;
  }
  .sales-button {
    height: 56px;
    width: 150px !important;
  }
  .box_link {
    align-items: baseline;
    justify-content: center;
    padding-top: 20px;
    height: 75px;
    display: flex;
  }
  p.nombre {
    font-size: 28px;
    margin-bottom: 32px;
  }
  div.mensaje-wrapper {
    color: #121212;
    font-size: 18px;
    margin-bottom: 42px;
    text-align: center;
  }
  div.button-container {
    text-align: center;
  }
  div.image {
    text-align: center;
  }
  .title {
    font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
    font-size: 26px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: center;
    color: #121212;
    margin-bottom: 8px;
    margin-top: 7px;
  }
  .subtitle {
    font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    color: #121212;
  }
  span.subtitle-sucursal {
    font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    line-height: 1.6;
    text-align: center;
    color: #121212;
  }
  .container {
    text-align: center;
  }
  .layout-centrado {
    grid-template-areas: ". . . col2 col2 col2 col2 col2 col2 . . ." !important;
  }
  .layout-centrado .title,
  .layout-centrado .subtitle {
    text-align: center;
  }
  .layout-centrado div.button-container,
  .layout-centrado div.image {
    text-align: center;
  }
  .dni {
    width: 149px;
    height: 105px;
  }
}
</style>
